import React from 'react';
import { CustomerSpecificData } from '../../../../Types';
import Icon from './Icon';
import { balloonPositionMap } from './BalloonPosition';

import './Badges.scss';

interface Props {
    customerSpecificData: CustomerSpecificData | null;
    alignment: 'left' | 'center' | 'right';
}

const InciBadge: React.FunctionComponent<Props> = (props) => {
    if (props.customerSpecificData === null) {
        return null;
    }
    const { passesIngredientsCheck, ingredientsContained, ingredientsNotContained } = props.customerSpecificData;

    // this combination suggests, that no ingredients have been excluded
    if (passesIngredientsCheck === true && ingredientsNotContained.length === 0) {
        return null;
    }

    return (
        <div
            className={
                'product-check' +
                ' ' +
                (passesIngredientsCheck === true ? 'product-check--ok' : 'product-check--warning') +
                ' ' +
                'product-check--' +
                props.alignment
            }
            aria-label={balloonText(passesIngredientsCheck, ingredientsContained, ingredientsNotContained)}
            data-balloon-pos={balloonPositionMap.get(props.alignment)}
            data-balloon-length="large"
        >
            <span>Inhaltsstoffe-Check</span>
            <Icon passesCheck={passesIngredientsCheck} />
        </div>
    );
};

const balloonText = (
    passesIngredientsCheck: boolean,
    ingredientsContained: string[],
    ingredientsNotContained: string[],
) => {
    if (passesIngredientsCheck === true) {
        return `Die von Ihnen hinterlegten Inhaltsstoffe ${ingredientsToSentence(
            ingredientsNotContained,
        )} sind in diesem Produkt nicht enthalten`;
    } else {
        return `Das Produkt enthält den im Inhaltsstoffe-Check eingetragenen Inhaltsstoff ${ingredientsToSentence(
            ingredientsContained,
        )}.
        Nach unserer Erfahrung ist die Anwendung vielfach z. B. aufgrund geringer Dosierung dennoch kein Problem.
        Wir empfehlen, zur Sicherheit bei Ihrer Beraterin einen Test in der Armbeuge durchzuführen, um eine mögliche Reaktion zu prüfen.`;
    }
};

const ingredientsToSentence = (ingredients: string[]) => {
    if (!Array.isArray(ingredients) || !ingredients.length) {
        return '';
    }

    if (ingredients.length === 1) {
        return '(' + ingredients[0] + ')';
    }

    const lastIngredient = ingredients.slice(ingredients.length - 1);
    // do not use `toSpliced` here to keep `LoggedIn` JS backwards compatible without pollyfills.
    // eslint-disable-next-line rulesdir/use-to-spliced-over-splice
    ingredients.splice(ingredients.length - 1);

    return '(' + ingredients.join(', ') + ' und ' + lastIngredient + ')';
};

export default InciBadge;
